import { render, staticRenderFns } from "./product-groups.vue?vue&type=template&id=281b15ee&scoped=true&"
import script from "./product-groups.vue?vue&type=script&lang=ts&"
export * from "./product-groups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281b15ee",
  null
  
)

export default component.exports